import { render } from "./OtpVerifyModal.vue?vue&type=template&id=1b923f14"
import script from "./OtpVerifyModal.vue?vue&type=script&lang=js"
export * from "./OtpVerifyModal.vue?vue&type=script&lang=js"

import "./OtpVerifyModal.vue?vue&type=style&index=0&id=1b923f14&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__